import { render, staticRenderFns } from "./DadosAno.vue?vue&type=template&id=23472a2c&"
import script from "./DadosAno.vue?vue&type=script&lang=ts&"
export * from "./DadosAno.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports